/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Ordered_ListInputs */

const en_common_editor_ordered_list = /** @type {(inputs: Common_Editor_Ordered_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordered list`)
};

const zh_common_editor_ordered_list = /** @type {(inputs: Common_Editor_Ordered_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有序列表`)
};

/**
* | output |
* | --- |
* | "Ordered list" |
*
* @param {Common_Editor_Ordered_ListInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_ordered_list = /** @type {((inputs?: Common_Editor_Ordered_ListInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Ordered_ListInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_ordered_list(inputs)
	return zh_common_editor_ordered_list(inputs)
});
export { common_editor_ordered_list as "common.editor.ordered_list" }